module.exports = __webpack_public_path__ + "assets/img/00119.0d8d89d9.png";